import { DesktopBridgeAvatarMenuSyncListener } from "../desktop-bridge/desktop-bridge-avatar-menu-sync-listener.js";
import { DesktopBridgeCallSyncListener } from "../desktop-bridge/desktop-bridge-call-sync-listener.js";
import { DesktopBridgeChatSyncListener } from "../desktop-bridge/desktop-bridge-chat-sync-listener.js";
import { DesktopBridgeConnectSyncListener } from "../desktop-bridge/desktop-bridge-connect-sync-listener.js";
import { DesktopBridgePositionSyncListener } from "../desktop-bridge/desktop-bridge-position-sync-listener.js";
import { DesktopBridgePresenceSyncListener } from "../desktop-bridge/desktop-bridge-presence-sync-listener.js";

export const TableCallDesktopBridgeListeners = ({
  enabled,
}: {
  enabled: boolean;
}) => {
  if (!enabled) {
    return null;
  }
  return (
    <>
      <DesktopBridgeChatSyncListener />
      <DesktopBridgeAvatarMenuSyncListener />
      <DesktopBridgeConnectSyncListener />
      <DesktopBridgePresenceSyncListener />
      <DesktopBridgePositionSyncListener />
      <DesktopBridgeCallSyncListener />
    </>
  );
};
